export default __webpack_public_path__ + "static/media/virtual_plus.5a533c72.png";